import { useState } from "react";
import Modal from "../../../components/Modal/Modal";
import { FILTER_PRODUCT_OPTIONS } from "../../../constants";
import { LabelFormFilter, TitleModalFilter } from "../style";
import { TagItem } from "./TagItem";
import { Col, Row, Space } from "antd";
import { MyButton } from "../../../components/Button/style";

export const ModalFilter = ({ onClose }) => {
  const [selected, setSelected] = useState({
    deposit: [],
    interest: [],
    type: [],
    status: [],
  });
  const onChange = (key, value, checked) => {
    if (checked) {
      setSelected({ ...selected, [key]: [...selected[key], value] });
    } else {
      setSelected({
        ...selected,
        [key]: selected[key].filter((item) => item !== value),
      });
    }
  };

  return (
    <Modal>
      <Modal.ModalBg onClick={onClose} />
      <Modal.Container onClose={onClose}>
        <TitleModalFilter>Filter Product Type</TitleModalFilter>
        <div className="mt-6">
          <div>
            <LabelFormFilter>Deposit</LabelFormFilter>
            <div className="mt-3">
              <Row gutter={[8, 8]}>
                {FILTER_PRODUCT_OPTIONS.deposit.map((item, index) => (
                  <Col key={index}>
                    <TagItem
                      onChange={(value, checked) =>
                        onChange("deposit", value, checked)
                      }
                      checked={selected.deposit.includes(item.value)}
                      label={item.label}
                      value={item.value}
                    />
                  </Col>
                ))}
              </Row>
            </div>
          </div>
          <div className="mt-8">
            <LabelFormFilter>Interest/Voting Right</LabelFormFilter>
            <div className="mt-3">
              <Row gutter={[8, 8]}>
                {FILTER_PRODUCT_OPTIONS.interest.map((item, index) => (
                  <Col key={index}>
                    <TagItem
                      onChange={(value, checked) =>
                        onChange("interest", value, checked)
                      }
                      checked={selected.interest.includes(item.value)}
                      label={item.label}
                      value={item.value}
                    />
                  </Col>
                ))}
              </Row>
            </div>
          </div>
          <div className="mt-8">
            <LabelFormFilter>Type</LabelFormFilter>
            <div className="mt-3">
              <Row gutter={[8, 8]}>
                {FILTER_PRODUCT_OPTIONS.type.map((item, index) => (
                  <Col key={index}>
                    <TagItem
                      onChange={(value, checked) =>
                        onChange("type", value, checked)
                      }
                      checked={selected.type.includes(item.value)}
                      label={item.label}
                      value={item.value}
                    />
                  </Col>
                ))}
              </Row>
            </div>
          </div>
          <div className="mt-8">
            <LabelFormFilter>Status</LabelFormFilter>
            <div className="mt-3">
              <Row gutter={[8, 8]}>
                {FILTER_PRODUCT_OPTIONS.status.map((item, index) => (
                  <Col key={index}>
                    <TagItem
                      onChange={(value, checked) =>
                        onChange("status", value, checked)
                      }
                      checked={selected.status.includes(item.value)}
                      label={item.label}
                      value={item.value}
                    />
                  </Col>
                ))}
              </Row>
            </div>
          </div>
        </div>
        <Space
          className="mt-[44px] lg:mt-[58px] justify-center w-full"
          size={16}
        >
          <MyButton>Reset</MyButton>
          <MyButton className="primary">Submit</MyButton>
        </Space>
      </Modal.Container>
    </Modal>
  );
};
